import { Flex } from "@chakra-ui/react";
import { HEADER_GROUP, useBookingRecoilValue, useNewNavigate } from "@shared/client";
import { getDefaultParameters } from "@utils/getDefaultParameters";
import { useState } from "react";
import { CustomBox, CustomButton, CustomLocalNavBar, CustomText, CustomTitle, Wrapper } from "./globalNavBar.style";
import { type GlobalNavBarProps } from "./globalNavBar.type";

export const GlobalNavBar = ({ navigation }: GlobalNavBarProps) => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const { co_id, idx } = getDefaultParameters();
    const { onNavigate } = useNewNavigate();
    const bookingEngine = useBookingRecoilValue();

    return (
        <Wrapper columnGap="80px">
            <Flex columnGap="32px">
                {HEADER_GROUP.map((menu, index) => {
                    return (
                        <CustomBox key={menu.title}>
                            <CustomTitle p="0 12px" onMouseOver={() => setActiveIndex(index)}>
                                {menu.title}
                            </CustomTitle>
                            <CustomLocalNavBar
                                onMouseLeave={() => setActiveIndex(null)}
                                className={activeIndex === index ? "on" : "off"}
                                flexDir="column"
                            >
                                {menu.title === "Specials" &&
                                    navigation?.specialList &&
                                    navigation.specialList.map((special) => (
                                        <CustomText
                                            onClick={() => onNavigate({ path: `specials/${special.specialIdx}` })}
                                            key={special.specialIdx}
                                            p="12px 0"
                                        >
                                            {special.specialName}
                                        </CustomText>
                                    ))}

                                {menu.title === "Rooms" &&
                                    navigation?.roomList &&
                                    navigation.roomList.map((room) => (
                                        <CustomText
                                            onClick={() => onNavigate({ path: `rooms/${room.roomIdx}` })}
                                            key={room.roomIdx}
                                            p="12px 0"
                                        >
                                            {room.roomName}
                                        </CustomText>
                                    ))}

                                {menu.title === "Reservation" &&
                                    menu.contents.map((content, contentIndex) => {
                                        const isCheck = content.title === "예약조회";

                                        if (bookingEngine.isGoogleBE && isCheck && contentIndex === 1) {
                                            return null;
                                        }

                                        return (
                                            <CustomText
                                                onClick={() => {
                                                    if (isCheck) {
                                                        return window.open(
                                                            `https://marginauto.kr/api/testCalendar/public/check.html?idx=${idx}&co_id=${co_id}`,
                                                            "_blank",
                                                        );
                                                    }

                                                    return window.open(bookingEngine.bookingUrl);
                                                }}
                                                key={content.title}
                                                p="12px 0"
                                            >
                                                {content.title}
                                            </CustomText>
                                        );
                                    })}

                                {menu.title !== "Reservation" &&
                                    menu.title !== "Rooms" &&
                                    menu.title !== "Specials" &&
                                    menu.contents.map((content) => {
                                        return (
                                            <CustomText
                                                onClick={() => onNavigate({ path: content.path })}
                                                key={content.title}
                                                p="12px 0"
                                            >
                                                {content.title}
                                            </CustomText>
                                        );
                                    })}
                            </CustomLocalNavBar>
                        </CustomBox>
                    );
                })}
            </Flex>
            <CustomButton
                iconNamed="notifications"
                size="medium"
                round="pill"
                onClick={() => window.open(bookingEngine.bookingUrl)}
            >
                실시간 예약
            </CustomButton>
        </Wrapper>
    );
};
